/**
 * Checks if the text contains unordered or ordered list or blockquote markdown patterns
 */
export const containsListOrBlockquoteMarkdown = (text: string): boolean => {
  // Check for patterns like "- item", "1. item", and "> text" at the beginning of a line
  const unorderedListPattern = /^(?:[\r\n]|^)\s*[-*+]\s+.+/m;
  const orderedListPattern = /^(?:[\r\n]|^)\s*\d+\.\s+.+/m;
  const blockquotePattern = /^(?:[\r\n]|^)\s*>\s+.+/m;
  return unorderedListPattern.test(text) || orderedListPattern.test(text) || blockquotePattern.test(text);
};

/**
 * Checks if the text contains non-inline markdown (headers, lists, blockquotes) patterns
 */
export const containsNonInlineMarkdown = (text: string): boolean => {
  return /^#{1,3}\s+.+/m.test(text) || containsListOrBlockquoteMarkdown(text);
};
